export default "__VITE_ASSET__58498f9d__"